import auth from "../api/auth";
import router from "@/router/index";

export const user = {
  state: () => ({
    user: {},
    loading: false,
    token: null,
  }),
  mutations: {
    USER_LOGIN(state, payload) {
      state.user = payload;
      state.token = payload.token;
    },
    SET_LOADING(state, payload) {
      state.loading = payload;
    },
    // Merge profile edits into the cached user without touching the token.
    UPDATE_USER(state, updates) {
      state.user = {
        ...state.user,
        ...updates,
      };
    },
    SET_KBB_VALUE(state, kbbValue) {
      state.user = {
        ...state.user,
        kbbValue: kbbValue,
      };
    },
    DELETE_KBB_VALUE(state) {
      state.user = {
        ...state.user,
        kbbValue: undefined,
        tradeInVehicle: false,
        tradeInDetails: undefined,
      };
    },
    UPDATE_KBB_VALUE(state, updates) {
      if (!state.user.kbbValue) {
        state.user = {
          ...state.user,
          kbbValue: {},
        };
      }
      state.user = {
        ...state.user,
        kbbValue: {
          ...state.user.kbbValue,
          ...updates,
          updatedAt: new Date().toISOString(),
        },
      };
    },
  },
  actions: {
    async login(context, payload) {
      context.commit("SET_LOADING", true);
      try {
        let res = await auth.login(payload.email, payload.password);
        if (res && res.data && res.data.data) {
          let headers = { headers: { authtoken: `${res.data.data.token}` } };
          localStorage.setItem("token", res.data.data.token);
          localStorage.setItem("headers", JSON.stringify(headers));
          context.commit("USER_LOGIN", res.data.data);
          context.commit("SET_LOADING", false);
          // Navigate to home after successful login
          if (localStorage.getItem("token")) {
            router.push({
              name: "Home",
            });
          }
        } else {
          throw new Error("Invalid response from server");
        }
      } catch (error) {
        console.error("Login failed:", error);
      } finally {
        context.commit("SET_LOADING", false);
      }
    },
    async adminLogin(context, payload) {
      context.commit("SET_LOADING", true);
      try {
        let res = await auth.adminLogin(payload.email, payload.password);
        if (res && res.data && res.data.data) {
          let headers = { headers: { authtoken: `${res.data.data.token}` } };
          localStorage.setItem("token", res.data.data.token);
          localStorage.setItem("headers", JSON.stringify(headers));
          context.commit("USER_LOGIN", res.data.data);
          context.commit("SET_LOADING", false);
          if (localStorage.getItem("token")) {
            router.push({ name: "Admin" });
          }
        } else {
          throw new Error("Invalid response from server");
        }
      } catch (error) {
        console.error("Admin login failed:", error);
        throw error;
      } finally {
        context.commit("SET_LOADING", false);
      }
    },
    async register(context, payload) {
      context.commit("SET_LOADING", true);
      try {
        let res = await auth.register(
          payload.fullName,
          payload.email,
          payload.password,
          payload.creditScore,
          payload.finance,
          payload.leasing,
          payload.city,
          payload.state,
          payload.zipCode,
          payload.phoneNumber,
          payload.tradeInVehicle,
          payload.tradeInDetails
        );
        if (res) {
          // localStorage.setItem("token", res.data.data.token);
          // context.commit('USER_LOGIN', res.data.data);
          // Route to the dedicated /registration-thank-you confirmation page
          // so the Meta Pixel CompleteRegistration event fires on a unique URL
          // (required for accurate Meta Ads conversion tracking). The slug is
          // distinct from the marketing site's /thank-you (contact-form) page
          // so the two conversions can be tracked independently.
          router.push({ name: "ThankYou" });
        }
        return res;
      } finally {
        context.commit("SET_LOADING", false);
      }
    },
    async fetchKbbValue(context, payload) {
      context.commit("SET_LOADING", true);
      try {
        const res = await someApi.getKbbValue(payload);
        if (res && res.data && res.data.kbbValue) {
          context.commit("SET_KBB_VALUE", res.data.kbbValue);
        }
      } catch (error) {
        console.error("Error fetching KBB value:", error);
      } finally {
        context.commit("SET_LOADING", false);
      }
    },
  },
  getters: {
    user: (state) => state.user,
    loading: (state) => state.loading,
    token: (state) => state.token,
  },
};
